import React from 'react'
import { Icon } from '@iconify/react'
const MaintenancePage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '85vh',
        gap: '16px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: '#B3CFFE',
        }}
      >
        <Icon
          icon="game-icons:auto-repair"
          style={{
            width: '50px',
            height: '50px',
            color: '#015ffb',
          }}
        />
      </div>
      <h1>Under Maintenance</h1>
      <h4
        style={{
          maxWidth: '40%',
          textAlign: 'center',
        }}
      >
        We are currently performing scheduled maintenance on Course
        Generator, affecting both the admin and learners' interfaces. The
        maintenance is expected to last from 6:30 to 7:30 GMT.
      </h4>
      <p>Thank you for your patience and cooperation.</p>
    </div>
  )
}

export default MaintenancePage
